export default __webpack_public_path__ + "static/media/char_body_006.9c13f43e.png";